(function () {
  'use strict';

  if (window.STJAttribution) return;

  var CFG = {
    storageKey: 'stj_attr_v1',
    cookieName: 'stj_attr',
    firstTouchDays: 90,
    lastTouchDays: 30,
    maxValueLength: 255,
    debounceMs: 600,
    consentTimeoutMs: 2500,
    requestMarker: 'stj_attr=1',
    // Optional: re-create GoKwik's own 24h UTM cookie (gk_utm_source) from our 30-day
    // last touch so GoKwik's dashboard keeps the source for purchases made after day 1.
    // Keep false until GoKwik confirms no UTM-based discount rule depends on that cookie.
    refreshGokwikUtmCookie: false
  };

  var DAY_MS = 864e5;

  // Last touch keeps every campaign signal; first touch keeps the UTM set only.
  var LT_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
    'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid',
    'fbclid', 'ttclid', 'msclkid'
  ];
  var FT_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];

  // Referrers that are part of the purchase flow, not a marketing touch.
  var IGNORED_REFERRERS = /(^|\.)(myshopify\.com|shopify\.com|shop\.app|gokwik\.co|gokwik\.in|razorpay\.com|rzp\.io|payu\.in|paytm\.com|paytm\.in|phonepe\.com|cashfree\.com|juspay\.in|ccavenue\.com|billdesk\.com|easebuzz\.in|snapmint\.com|getsimpl\.com|paypal\.com|stripe\.com|accounts\.google\.com)$/i;
  var EMAIL_REFERRERS = /(^|\.)(mail\.google\.com|com\.google\.android\.gm|outlook\.live\.com|outlook\.office\.com|outlook\.office365\.com|mail\.yahoo\.com|mail\.zoho\.com|mail\.zoho\.in)$/i;
  var WHATSAPP_REFERRERS = /(^|\.)(whatsapp\.com|wa\.me|com\.whatsapp|com\.whatsapp\.w4b)$/i;
  var SEARCH_REFERRERS = /(^|\.)(google\.[a-z.]+|com\.google\.android\.googlequicksearchbox|bing\.com|yahoo\.[a-z.]+|duckduckgo\.com|yandex\.[a-z.]+|ecosia\.org|baidu\.com|search\.brave\.com)$/i;
  var SOCIAL_REFERRERS = /(^|\.)(facebook\.com|fb\.com|fb\.me|instagram\.com|com\.instagram\.android|com\.facebook\.katana|com\.facebook\.orca|t\.co|twitter\.com|x\.com|linkedin\.com|lnkd\.in|pinterest\.[a-z.]+|pin\.it|youtube\.com|youtu\.be|reddit\.com|threads\.net|snapchat\.com|tiktok\.com|telegram\.org|t\.me)$/i;
  var BOT_UA = /bot|crawl|spider|slurp|lighthouse|headless|pagespeed|preview/i;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var CHECKOUT_BUTTONS = '.gokwik-checkout button, #gokwik-buy-now';

  var DEBUG = false;
  try {
    DEBUG = /(^|[?&])stj_debug=1(&|$)/.test(location.search) ||
      window.localStorage.getItem('stj_attr_debug') === '1';
  } catch (e) { /* storage blocked */ }

  function log() {
    if (!DEBUG || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[stj-attr]');
    console.log.apply(console, args);
  }

  function now() { return new Date().getTime(); }

  /* ------------------------------------------------------------------ helpers */

  // Strip anything that could break HTML/JSON contexts or carry junk; cap length.
  function clean(v) {
    if (v === null || v === undefined) return '';
    v = String(v).replace(/[\u0000-\u001f\u007f<>"'`\\]/g, '').replace(/\s+/g, ' ').trim();
    return v.length > CFG.maxValueLength ? v.slice(0, CFG.maxValueLength) : v;
  }

  // Manual parser: tolerant of bad escapes, lower-cases keys, first value wins.
  function getParams(search) {
    var out = {};
    var q = String(search || '').replace(/^\?/, '');
    if (!q) return out;
    var pairs = q.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      if (!pair) continue;
      var eq = pair.indexOf('=');
      var k = eq < 0 ? pair : pair.slice(0, eq);
      var v = eq < 0 ? '' : pair.slice(eq + 1);
      try { k = decodeURIComponent(k.replace(/\+/g, ' ')).toLowerCase(); } catch (e) { continue; }
      try { v = decodeURIComponent(v.replace(/\+/g, ' ')); } catch (e) { /* keep raw */ }
      if (!Object.prototype.hasOwnProperty.call(out, k)) out[k] = v;
    }
    return out;
  }

  // Works for http(s) and android-app:// referrers (Gmail, WhatsApp, Instagram apps).
  function hostOf(url) {
    var m = /^[a-z][a-z0-9+.\-]*:\/\/([^\/?#:]+)/i.exec(url || '');
    return m ? m[1].toLowerCase() : '';
  }

  // Referrer without query/fragment (no PII, no tracking tokens).
  function stripUrl(url) {
    return clean(String(url || '').split('#')[0].split('?')[0]);
  }

  function readCookie(name) {
    var all = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < all.length; i++) {
      var part = all[i];
      var eq = part.indexOf('=');
      if (eq < 0) continue;
      if (part.slice(0, eq).replace(/^\s+|\s+$/g, '') !== name) continue;
      try { return decodeURIComponent(part.slice(eq + 1)); } catch (e) { return null; }
    }
    return null;
  }

  // `value` must already be cookie-safe (URI-encoded).
  function writeCookie(name, value, maxAgeSeconds) {
    try {
      document.cookie = name + '=' + value +
        '; path=/; max-age=' + Math.max(0, Math.floor(maxAgeSeconds)) +
        '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) { /* cookies blocked */ }
  }

  /* --------------------------------------------------------- classification */

  function classify(t, refHost) {
    var src = String(t.utm_source || '').toLowerCase();
    var med = String(t.utm_medium || '').toLowerCase();
    var both = src + ' ' + med;
    var paidMedium = /paid|(^|[^a-z])(cpc|ppc|cpm|cpv|cpa|ads?|sem|display|retarget\w*|remarketing)([^a-z]|$)/.test(med);
    var socialSource = /facebook|instagram|meta|tiktok|snapchat|pinterest|linkedin|twitter|youtube|threads|^(fb|ig|an|msg|x|yt)$/.test(src);

    if (/whatsapp|(^|[^a-z])wa([^a-z]|$)|interakt|wati|gupshup/.test(both)) return 'whatsapp';
    if (/(^|[^a-z])sms([^a-z]|$)/.test(both)) return 'sms';
    if (/e-?mail|newsletter|klaviyo/.test(both)) return 'email';
    if (t.ttclid) return 'paid_social';
    if (t.gclid || t.gbraid || t.wbraid || t.gad_source || t.msclkid) {
      return paidMedium && socialSource ? 'paid_social' : 'paid_search';
    }
    if (paidMedium) {
      if (socialSource || /social/.test(med)) return 'paid_social';
      if (/display|cpm|cpv|banner|video|retarget|remarketing/.test(med)) return 'paid_other';
      if (/google|bing|yahoo|search|sem|cpc|ppc/.test(both)) return 'paid_search';
      return 'paid_other';
    }
    if (/affiliate|influencer|partner/.test(med)) return 'affiliate';
    if (/social/.test(med) || socialSource || t.fbclid) return 'organic_social';
    if (/organic|seo/.test(med)) return 'organic_search';
    if (/referral/.test(med)) return 'referral';
    if (src || med || t.utm_campaign) return 'campaign_other';
    if (refHost) {
      if (EMAIL_REFERRERS.test(refHost)) return 'email';
      if (WHATSAPP_REFERRERS.test(refHost)) return 'whatsapp';
      if (SEARCH_REFERRERS.test(refHost)) return 'organic_search';
      if (SOCIAL_REFERRERS.test(refHost)) return 'organic_social';
      return 'referral';
    }
    return 'direct';
  }

  /* ------------------------------------------------------------- touch model */

  // kind: campaign | referral | direct | internal
  function buildTouch(params, refUrl, refHost, ownHosts) {
    var t = {};
    var hasCampaign = false;
    for (var i = 0; i < LT_KEYS.length; i++) {
      var v = clean(params[LT_KEYS[i]]);
      if (v) { t[LT_KEYS[i]] = v; hasCampaign = true; }
    }
    var bareHost = refHost.replace(/^www\./, '');
    var internal = !!refHost && (ownHosts.indexOf(bareHost) !== -1 || IGNORED_REFERRERS.test(refHost));
    var external = !!refHost && !internal;

    t.referrer = external ? stripUrl(refUrl) : '';
    t.landing_page = clean(location.pathname);
    t.at = new Date(now()).toISOString();
    t.channel = classify(t, external ? refHost : '');
    t.kind = hasCampaign ? 'campaign' : external ? 'referral' : internal ? 'internal' : 'direct';
    return t;
  }

  function stamp(touch, days) {
    var rec = {};
    for (var k in touch) {
      if (Object.prototype.hasOwnProperty.call(touch, k) && k !== 'kind') rec[k] = touch[k];
    }
    rec.exp = now() + days * DAY_MS;
    return rec;
  }

  function sameTouch(a, b) {
    var keys = LT_KEYS.concat(['referrer', 'landing_page']);
    for (var i = 0; i < keys.length; i++) {
      if ((a[keys[i]] || '') !== (b[keys[i]] || '')) return false;
    }
    return true;
  }

  // Returns true when the store changed and must be written back.
  function updateStore(store, touch) {
    var ts = now();
    var changed = false;
    if (store.ft && !(store.ft.exp > ts)) { store.ft = null; changed = true; }
    if (store.lt && !(store.lt.exp > ts)) { store.lt = null; changed = true; }

    // Internal/checkout referrer with nothing stored: we do not know the real source.
    if (touch.kind === 'internal') touch.channel = 'unknown';

    if (!store.ft) {
      store.ft = stamp(touch, CFG.firstTouchDays);
      changed = true;
    }

    var isNewTouch = touch.kind === 'campaign' || touch.kind === 'referral';
    // Last NON-DIRECT touch: direct/internal visits never overwrite an existing touch.
    if (!store.lt || (isNewTouch && !sameTouch(store.lt, touch))) {
      store.lt = stamp(touch, CFG.lastTouchDays);
      changed = true;
    }
    return changed;
  }

  function readStore() {
    var raw = null;
    try { raw = window.localStorage.getItem(CFG.storageKey); } catch (e) { /* blocked */ }
    if (!raw) raw = readCookie(CFG.cookieName);
    try {
      var s = raw ? JSON.parse(raw) : null;
      if (s && typeof s === 'object') {
        return {
          ft: s.ft && typeof s.ft === 'object' ? s.ft : null,
          lt: s.lt && typeof s.lt === 'object' ? s.lt : null
        };
      }
    } catch (e) { /* corrupt, start over */ }
    return { ft: null, lt: null };
  }

  function slim(rec) {
    if (!rec) return null;
    var keep = FT_KEYS.concat(['channel', 'at', 'exp', 'landing_page', 'gclid']);
    var out = {};
    for (var i = 0; i < keep.length; i++) if (rec[keep[i]]) out[keep[i]] = rec[keep[i]];
    return out;
  }

  function writeStore(store) {
    var json = JSON.stringify({ v: 1, ft: store.ft, lt: store.lt });
    try { window.localStorage.setItem(CFG.storageKey, json); } catch (e) { /* blocked */ }

    var ts = now();
    var maxAge = Math.max(
      store.ft ? (store.ft.exp - ts) / 1000 : 0,
      store.lt ? (store.lt.exp - ts) / 1000 : 0
    );
    var value = encodeURIComponent(json);
    if (value.length > 3800) {
      value = encodeURIComponent(JSON.stringify({ v: 1, ft: slim(store.ft), lt: slim(store.lt) }));
    }
    if (value.length <= 3800) writeCookie(CFG.cookieName, value, maxAge);
  }

  /* ----------------------------------------------------------- cart attributes */

  function desiredAttributes(store) {
    var lt = store.lt || {};
    var ft = store.ft || {};
    var out = {};
    var i;
    for (i = 0; i < LT_KEYS.length; i++) out[LT_KEYS[i]] = lt[LT_KEYS[i]] || '';
    out.referrer = lt.referrer || '';
    out.landing_page = lt.landing_page || '';
    out.traffic_channel = lt.channel || '';
    out.touch_at = lt.at || '';
    for (i = 0; i < FT_KEYS.length; i++) out['first_' + FT_KEYS[i]] = ft[FT_KEYS[i]] || '';
    out.first_referrer = ft.referrer || '';
    out.first_landing_page = ft.landing_page || '';
    out.first_traffic_channel = ft.channel || '';
    out.first_touch_at = ft.at || '';
    return out;
  }

  // Only changed keys. Blank values are sent only to clear a key the cart already has.
  function diffAttributes(want, have) {
    have = have || {};
    var d = {};
    var n = 0;
    for (var k in want) {
      if (!Object.prototype.hasOwnProperty.call(want, k)) continue;
      var w = want[k];
      var present = Object.prototype.hasOwnProperty.call(have, k) && have[k] !== null && have[k] !== undefined;
      var h = present ? String(have[k]) : '';
      if (w === h) continue;
      if (w === '' && !present) continue;
      d[k] = w;
      n++;
    }
    return n ? d : null;
  }

  function xhr(method, url, body, cb) {
    var req;
    try {
      req = new XMLHttpRequest();
      req.open(method, url, true);
      req.setRequestHeader('Accept', 'application/json');
      if (body) req.setRequestHeader('Content-Type', 'application/json');
      req.timeout = 10000;
    } catch (e) { cb(e); return; }
    req.onload = function () {
      var json = null;
      try { json = JSON.parse(req.responseText); } catch (e) { /* not JSON */ }
      if (req.status >= 200 && req.status < 300 && json) cb(null, json);
      else cb(new Error('HTTP ' + req.status));
    };
    req.onerror = function () { cb(new Error('network')); };
    req.ontimeout = function () { cb(new Error('timeout')); };
    req.send(body ? JSON.stringify(body) : null);
  }

  var data = null;
  var desired = null;
  var cartState = { itemCount: 0, attrs: {} };
  var synced = false;
  var inflight = false;
  var refreshTimer = null;

  function withMarker(url) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + CFG.requestMarker;
  }

  // The store is shared by every tab. Another tab may have saved a newer touch since this
  // page started, so re-read it rather than push this page's older copy over the cart.
  // Only the full localStorage copy is used (the cookie can be a slimmed copy), and an
  // empty read keeps the current value, so nothing is ever cleared by this.
  function refreshDesired() {
    if (!desired) return;
    var raw = null;
    try { raw = window.localStorage.getItem(CFG.storageKey); } catch (e) { return; }
    if (!raw) return;
    var s = readStore();
    if (s.ft || s.lt) desired = desiredAttributes(s);
  }

  function applyCart(cart) {
    cartState.itemCount = typeof cart.item_count === 'number' ? cart.item_count : 0;
    cartState.attrs = cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
    refreshDesired();
    synced = !!desired && !diffAttributes(desired, cartState.attrs);
  }

  function pushAttributes(allowEmptyCart) {
    if (!desired) return;
    refreshDesired();
    var changes = diffAttributes(desired, cartState.attrs);
    if (!changes) { synced = true; return; }
    if (!cartState.itemCount && !allowEmptyCart) return;
    // An in-flight POST already carries this page's values; its response re-reads the
    // store (applyCart), and a newer touch or a failed POST leaves `synced` false, so the
    // next trigger sends what is still missing.
    if (inflight) return;

    inflight = true;
    log('updating cart attributes', changes);
    xhr('POST', withMarker(data.cartUpdateUrl + '.js'), { attributes: changes }, function (err, cart) {
      inflight = false;
      if (err) log('cart update failed', err);
      else applyCart(cart);
    });
  }

  function refreshCart() {
    xhr('GET', withMarker(data.cartUrl + '.js'), null, function (err, cart) {
      if (err) { log('cart read failed', err); return; }
      applyCart(cart);
      if (!synced) pushAttributes(false);
    });
  }

  // Another script added/changed items. Once synced, attributes stay on the cart
  // (/cart/clear.js keeps them too), so there is nothing more to do.
  function onCartMutation() {
    if (!desired || synced) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, CFG.debounceMs);
  }

  function watchCartRequests() {
    if (typeof window.PerformanceObserver === 'function') {
      try {
        var po = new PerformanceObserver(function (list) {
          var entries = list.getEntries();
          for (var i = 0; i < entries.length; i++) {
            var name = entries[i].name || '';
            if (name.indexOf(CFG.requestMarker) !== -1) continue; // our own request
            if (CART_MUTATION.test(name)) { onCartMutation(); return; }
          }
        });
        po.observe({ type: 'resource', buffered: false });
        return;
      } catch (e) { /* older browser: fall through */ }
    }
    // Fallback: Dawn's pub/sub (assets/pubsub.js + constants.js).
    try {
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, onCartMutation);
      }
    } catch (e) { /* ignore */ }
  }

  // Head start on checkout: pointerdown fires before GoKwik's onclick opens the modal.
  function watchCheckoutButtons() {
    var handler = function (e) {
      if (!desired || synced) return;
      var t = e.target;
      if (!t || typeof t.closest !== 'function' || !t.closest(CHECKOUT_BUTTONS)) return;
      pushAttributes(true);
    };
    var opts = { capture: true, passive: true };
    try {
      document.addEventListener('pointerdown', handler, opts);
      document.addEventListener('click', handler, opts);
    } catch (e) {
      document.addEventListener('click', handler, true);
    }
  }

  /* ---------------------------------------------------- GoKwik cookie (opt-in) */

  function refreshGokwikCookie(lt) {
    if (!CFG.refreshGokwikUtmCookie || !lt || readCookie('gk_utm_source')) return;
    var src = lt.utm_source ||
      (lt.gclid || lt.gbraid || lt.wbraid || lt.gad_source ? 'google' :
        lt.fbclid ? 'facebook' : lt.msclkid ? 'bing' : '');
    if (!src) return;
    // Same shape GoKwik's merchant.integration.js writes: raw pairs, whole string encoded once.
    var pairs = [
      ['utm_source', src], ['utm_campaign', lt.utm_campaign], ['utm_medium', lt.utm_medium],
      ['utm_content', lt.utm_content], ['utm_term', lt.utm_term]
    ];
    var parts = [];
    for (var i = 0; i < pairs.length; i++) {
      if (pairs[i][1]) parts.push(pairs[i][0] + '=' + String(pairs[i][1]).replace(/[&=;]/g, ' '));
    }
    writeCookie('gk_utm_source', encodeURIComponent(parts.join('&')), DAY_MS / 1000);
  }

  /* ------------------------------------------------------------------ consent */

  function analyticsAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return true;
    try { return cp.analyticsProcessingAllowed() !== false; } catch (e) { return true; }
  }

  function whenConsentKnown(cb) {
    var S = window.Shopify;
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      cb(analyticsAllowed());
    };
    if ((S && S.customerPrivacy) || !S || typeof S.loadFeatures !== 'function') { finish(); return; }
    try {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
    } catch (e) { finish(); return; }
    setTimeout(finish, CFG.consentTimeoutMs);
  }

  /* --------------------------------------------------------------------- boot */

  function readData() {
    var d = {};
    try {
      var el = document.getElementById('stj-attribution-data');
      if (el) d = JSON.parse(el.textContent || '{}') || {};
    } catch (e) { d = {}; }
    // Fallback: `var cart = {{ cart | json }}` in snippets/gokwik.liquid.
    var gk = window.cart && typeof window.cart === 'object' && !window.cart.nodeType ? window.cart : null;
    var routes = window.routes || {};
    var hosts = String(d.hosts || '').toLowerCase().split(',');
    hosts.push(String(location.hostname || '').toLowerCase());
    for (var i = 0; i < hosts.length; i++) hosts[i] = hosts[i].replace(/^\s+|\s+$/g, '').replace(/^www\./, '');
    return {
      itemCount: typeof d.itemCount === 'number' ? d.itemCount : (gk && gk.item_count) || 0,
      attributes: d.attributes && typeof d.attributes === 'object' ? d.attributes : (gk && gk.attributes) || {},
      cartUrl: d.cartUrl || routes.cart_url || '/cart',
      cartUpdateUrl: d.cartUpdateUrl || routes.cart_update_url || '/cart/update',
      hosts: hosts,
      designMode: !!d.designMode
    };
  }

  var touch = null;
  var started = false;

  function start(allowed) {
    if (started) return;
    if (!allowed) { log('analytics consent not given, waiting'); return; }
    started = true;

    var store = readStore();
    if (updateStore(store, touch)) writeStore(store);
    desired = desiredAttributes(store);
    refreshGokwikCookie(store.lt);
    log('touch', touch, 'store', store);

    synced = !diffAttributes(desired, cartState.attrs);
    if (synced) return;
    // Sync now if checkout is reachable from this page: the cart has items, or a
    // GoKwik Buy Now button is here (ad click -> product page -> Buy Now).
    if (cartState.itemCount > 0 || document.getElementById('gokwik-buy-now')) pushAttributes(true);
  }

  function init() {
    data = readData();
    if (data.designMode || (window.Shopify && window.Shopify.designMode)) return;
    if (navigator.webdriver || BOT_UA.test(navigator.userAgent || '')) return;

    cartState.itemCount = data.itemCount;
    cartState.attrs = data.attributes;

    // Read the URL and referrer now, before any script can change them.
    var refUrl = document.referrer || '';
    touch = buildTouch(getParams(location.search), refUrl, hostOf(refUrl), data.hosts);

    watchCartRequests();
    watchCheckoutButtons();
    whenConsentKnown(start);
    document.addEventListener('visitorConsentCollected', function () { start(analyticsAllowed()); });
  }

  window.STJAttribution = {
    get: function () { return readStore(); },
    desired: function () { return desired; },
    sync: function () { synced = false; refreshCart(); },
    _classify: classify,
    _getParams: getParams
  };

  try { init(); } catch (e) { log('init failed', e); }
})();
